import request from "./request";
const API_PREFIX = "/mp/file";

/**
 * 上传文件（multipart/form-data，字段名 file）
 * @param {FormData} data - 需包含 append('file', File|Blob)
 * @returns {Promise<*>} 成功时 data 一般为 { url } 或字符串，见 parseUploadUrl
 */
export function uploadFile(data) {
  return request({
    url: `${API_PREFIX}/upload`,
    method: "post",
    data,
  });
}
